import React from 'react';

const Spinner = () => {
  return (
    <>
   <div className="d-flex justify-content-center align-items-center vh-100">
  <div
  style={{height: "75px", width:"75px"}}
   className="spinner-border text-info me-2" role="status">
    <span >Loading...</span>
  </div>
  
</div>

    </>
  );
}

export default Spinner;
